import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const [form, setForm]       = useState({ login: '', password: '' });
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const user = await login(form.login, form.password);
      if (user.role === 'ADMIN') navigate('/admin');
      else if (user.role === 'AUXILIAR_ADM') navigate('/auxiliar');
      else if (user.role === 'COORDENADOR_GERAL') navigate('/dashboard');
      else navigate('/perfil');
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao fazer login');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/favicon.ico" alt="Logo" style={{ width:52, height:52, objectFit:'contain', marginBottom:4 }} />
          <h1 className="auth-title">POLITICS SYSTEM</h1>
          <p className="auth-sub">Plataforma de Gestão de Campanha</p>
        </div>

        <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
          <div className="field-group">
            <label className="r-label">LOGIN</label>
            <input className="r-input" value={form.login}
              onChange={e => setForm({...form, login: e.target.value})}
              placeholder="Seu login" autoComplete="username" required />
          </div>
          <div className="field-group">
            <label className="r-label">SENHA</label>
            <input className="r-input" type="password" value={form.password}
              onChange={e => setForm({...form, password: e.target.value})}
              placeholder="Sua senha" autoComplete="current-password" required />
          </div>
          {error && <div className="alert alert-danger">{error}</div>}
          <button className="btn" disabled={loading}
            style={{ padding:'13px', fontSize:14, letterSpacing:2, marginTop:4 }}>
            {loading ? 'ENTRANDO...' : 'ACESSAR'}
          </button>
        </form>

        {/* Esqueci minha senha */}
        <div style={{ textAlign:'center', marginTop:8 }}>
          <Link to="/recuperar-senha"
            style={{ fontSize:13, color:'#000080', textDecoration:'none', fontWeight:600 }}>
            Esqueci minha senha
          </Link>
        </div>

        {/* Rodapé */}
        <div style={{ marginTop:20, borderTop:'1px solid #e0e0e0', paddingTop:18,
          display:'flex', flexDirection:'column', alignItems:'center', gap:10 }}>

          <p style={{ fontSize:11, color:'#888', textAlign:'center', margin:0 }}>
            Todos os direitos reservados PoliticSYS©
          </p>

          <a href="https://www.analysis-pro.com.br" target="_blank" rel="noreferrer"
            style={{ fontSize:12, color:'#000080', fontWeight:600, textDecoration:'underline' }}>
            analysis-pro.com.br
          </a>
        </div>
      </div>
    </div>
  );
}
